module.exports = __webpack_public_path__ + "static/media/invoice.a3d65a5d.svg";